import { useSyncExternalStore } from "react";

/**
 * Where the support and tutorial launchers should render right now.
 *
 * They normally float in the bottom-right corner. The Review modal is the one
 * surface that cannot let them do that: its Bootstrap shell is a transparent
 * full-viewport layer, so it sits over the corner and takes every click aimed
 * at them (#866, #906, #916 all circled this). While that modal is open it
 * mounts a dock in the gap under its dialog and the launchers render into it
 * instead — inside the shell, where nothing can cover them, because a layer
 * cannot cover its own children.
 */
let dockElement = null;
const subscribers = new Set();

/** Callback ref for the dock: React passes the node on mount, null on unmount. */
export function setLauncherDock(element) {
  dockElement = element;
  subscribers.forEach((notify) => notify());
}

function subscribe(notify) {
  subscribers.add(notify);
  return () => subscribers.delete(notify);
}

function getDockElement() {
  return dockElement;
}

export function useLauncherDock() {
  return useSyncExternalStore(subscribe, getDockElement, getDockElement);
}
